<template>
  <div v-show="show">
    <div
      v-show="openBrowserTips"
      @click="openBrowserTips = !openBrowserTips"
      class="open-browser-tips"
    >
      <img class="tips" src="@/assets/evokeapp/open-browser-tips.png" />
    </div>
    <a class="open-app-popup" v-if="supportUniversal" :href="universalLink">
    </a>
    <div v-else class="open-app-popup" @click="openDialog(true)"></div>
  </div>
</template>
<script lang="ts">
import { t } from "i18n";

import Vue from "vue";
import { utils } from "msb-public-library";
import { openApp } from "@/utils/openApp";
import { Dialog } from "vant";
import { isInWechatMP } from "@/utils/util";

interface IData {
  show: boolean;
  openBrowserTips: boolean;
}
export default Vue.extend({
  data(): IData {
    return {
      show: false,
      openBrowserTips: false
    };
  },

  methods: {
    openApp(fallback?: boolean | undefined) {
      let type = "native";
      let url = "home";
      if (this.name === "myCourses") {
        type = "native";
        url = "timetable";
      }
      openApp({ type, url }, fallback);
    },
    openDialog(fallback?: boolean | undefined) {
      console.log("openDialog :>> ", fallback);
      Dialog.confirm({
        message: t("src_components_openApp_popup_a97b40b2")
      })
        .then(() => {
          if (utils.client.android && utils.client.weixinwebview) {
            this.openBrowserTips = true;
          } else {
            if (utils.client.ios) {
              location.href = this.universalLink;
            } else {
              this.openApp(fallback);
            }
          }
        })
        .catch(() => {
          // on cancel
        });
    }
  },

  computed: {
    isParentMiniProgram(): boolean {
      return this.$route.query.parentMiniProgram || isInWechatMP();
    },
    name(): string {
      return this.$route.name || "";
    },
    supportUniversal(): boolean {
      return utils.client.ios && utils.client.weixinwebview;
    },
    universalLink(): string {
      // 课表跳转原生课表页面，其他打开APP首页
      if (this.name === "myCourses") {
        const APP_ENV = import.meta.env.VITE_APP_ENV;
        if (APP_ENV === "live") {
          return "https://17p.me/a/xj6Rl"; // 线上环境我的课表
        }
        return "https://17p.me/a/xkcFf"; // 测试环境我的课表
      }
      return "https://17p.me/a/xiQr0"; // APP 首页
    }
  },

  watch: {
    name(name) {
      let showlists = [
        "studentPersonalCenter", // 个人中心
        "myCourses", // 我的课程
        "studentLessonDetail", // 课时明细
        "leaveDetail", // 请假明细
        "studentWxMyOrder", // 我的订单
        "packageList", // 物流信息
        "shippingAddress", // 收获地址
        "scheduleClassesList", // 自主约课
        "studentInviteDetail", // 邀请明细
        "userCoupon", // 优惠券
      ];
      // 20230310 兼容家长小程序
      if (this.isParentMiniProgram) {
        showlists = showlists.filter(i => i !== "studentLessonDetail");
      }
      console.log("name :>> ", name);
      if (showlists.includes(name as string)) {
        this.show = true;
        if (name !== "studentPersonalCenter" && name !== "myCourses") {
          this.openDialog();
        }
      }
    }
  }
});
</script>
<style lang="scss" scoped>
.open-browser-tips {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.7);
  z-index: 999;
  .tips {
    position: absolute;
    top: 0;
    right: 58px;
    width: 360px;
    height: 280px;
  }
}
.open-app-popup {
  position: fixed;
  right: 0;
  z-index: 999;
  bottom: 120px;
  width: 316px;
  height: 88px;
  cursor: pointer;
  background-image: url("@/assets/evokeapp/popup.png");
  background-repeat: no-repeat;
  background-size: contain;
  animation: bounceInLeft 500ms linear 3s;
  animation-fill-mode: both;

  @keyframes bounceInLeft {
    from,
    60%,
    75%,
    90%,
    to {
      -webkit-animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
      animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
    }

    0% {
      transform: translate3d(0, 0, 0);
    }

    60% {
      transform: translate3d(230px, 0, 0);
    }

    75% {
      transform: translate3d(220px, 0, 0);
    }

    90% {
      transform: translate3d(225px, 0, 0);
    }

    to {
      transform: translate3d(230px, 0, 0);
    }
  }
}
</style>
